__turbopack_context__.v({
  "ant-collapse-arrow": "plmeAW_ant-collapse-arrow",
  "ant-collapse-content": "plmeAW_ant-collapse-content",
  "ant-collapse-content-box": "plmeAW_ant-collapse-content-box",
  "ant-collapse-header": "plmeAW_ant-collapse-header",
  "collapse": "plmeAW_collapse",
  "last-panel-wrapper": "plmeAW_last-panel-wrapper",
  "panel-wrapper": "plmeAW_panel-wrapper",
});
